import { css } from '@emotion/css';
import { type JSX } from 'react';
import { uiConfig } from '../../../services/config';

const container = css`
  display: flex;
  flex-direction: row;
`;

const boxContainer = css`
  width: 80px;
  height: 80px;
  min-width: 80px;
  aspect-ratio: 1;
  @media (min-width: 480px) {
    max-width: 160px;
    max-height: 160px;
    min-width: 80px;
    width: auto;
    height: auto;
  }
`;
const detailStyle = (
  textColor: string,
  fontSize: string,
  fontWeight: string,
  marginTop: string,
): string => css`
  margin: 0;
  color: ${textColor};
  font-weight: ${fontWeight};
  font-size: ${fontSize};
  margin-top: ${marginTop};
  ::first-letter {
    text-transform: capitalize;
  }
`;
const detailsStyle = css`
  font-family: ${uiConfig.styles.fontFamily};
  font-style: normal;
  align-self: center;
  padding-left: 24px;
  display: flex;
  flex-direction: column;
`;

export interface JourneyItem {
  imgSrc: string;
  alt: string;
  title: string;
  description: string;
}

interface JourneyListItemProps {
  item: JourneyItem;
}

export function JourneyListItem({ item }: JourneyListItemProps): JSX.Element {
  return (
    <div className={container}>
      <div className={boxContainer}>
        <img
          src={item.imgSrc}
          alt={item.alt}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            borderRadius: '14px',
          }}
          role="presentation"
        />
      </div>
      <div className={detailsStyle}>
        <div className={detailStyle('black', '21px', '700', '0px')}>
          {item.title}
        </div>
        <div className={detailStyle('black', '16px', '400', '4px')}>
          {item.description}
        </div>
      </div>
    </div>
  );
}
